import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ConnectionStatusRoute,
  ConnectionStatusPathName,
} from '@/modules/ta/connectionstatus/connectionstatus.constants';
import {
  DataLoadStatusRoute,
  DataLoadTabValues,
} from '@/modules/ta/dataloadstatus/dataloadstatus.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ConnectionStatusRoute.CONNECTIONSTATUS}`,
      name: ConnectionStatusPathName.CONNECTIONSTATUS,
      redirect: `/${DataLoadStatusRoute.DATALOADSTATUS}/tab/${DataLoadTabValues.NEEDS_ATTENTION}`,
    },
  ],
  Module.CONNECTIONSTATUS
);
